import { render, staticRenderFns } from "./GalleryItemList.vue?vue&type=template&id=15092af1&"
import script from "./GalleryItemList.vue?vue&type=script&lang=js&"
export * from "./GalleryItemList.vue?vue&type=script&lang=js&"
import style0 from "./GalleryItemList.vue?vue&type=style&index=0&id=15092af1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports